<template>
    <button :disabled="isLoading" :class="{'active': likedByMe}" class="btn btn-like fw-bold ps-0" @click="toggleLikedByMe" >
      <i class="fa-thumbs-up" :class="thumbsClass" aria-hidden="true"></i> {{numberOfLikes}} <span class="sr-only">Likes erhalten</span>
    </button>
</template>
<script lang="ts">



import { defineComponent } from 'vue'
import likeService  from '@/services/likeService'
import { LikeCategory } from '../../models/LikeCategory'

export default defineComponent({
  name: 'Likes',
  props: {
    likedContentUuid: String,
    bundleId: String,
    category: String
  },
  emits: ['likesUpdated'],
  data() {
    return {
      likedByMe: false,
      numberOfLikes: 0,
      contentId: "",
      likeCategory: LikeCategory.articles,
      isLoading: false,
      thumbsClass: "far",
    };
  },
  mounted() {
    if (this.category !== undefined) {
      if (this.category === "articles") {
        this.likeCategory = LikeCategory.articles;
      } else if (this.category === "comments") {
        this.likeCategory = LikeCategory.comments;
      }
    }
    if (this.likedContentUuid !== undefined) {
      this.contentId = this.likedContentUuid;
    }
    this.getLikesCount();
    this.checkLikedByMe();
  },
  methods: {

    toggleLikedByMe(): Promise<void> {
        this.isLoading = true;
        return likeService.toggleLike(this.likeCategory, this.contentId, this.bundleId).then(tlr => {
          this.likedByMe = tlr.likedByMe;
          this.thumbsClass = this.likedByMe ? "fas" : "far";
          this.numberOfLikes = tlr.numberOfLikes;
          this.isLoading = false;
          this.$emit('likesUpdated')
          // return tlr // We don't need to return this
          return;
        }).catch(() => {
          this.isLoading = true;
        });
    },

    checkLikedByMe(): Promise<boolean> {
      this.isLoading = true;
      return likeService.isLikedByMe(this.contentId, this.bundleId).then((liked) => {
        this.likedByMe = liked;
        this.thumbsClass = this.likedByMe ? "fas" : "far";
        this.isLoading = false;
        return liked;
      }).catch(() => {
        this.isLoading = true;
        return false;
      });
    },

    getLikesCount(): Promise<number> {
      this.isLoading = true
      return likeService.getLikes(this.likeCategory, this.contentId, this.bundleId)
      .then(cl => {
        this.numberOfLikes = (cl.likes !== undefined ? cl.likes : 0);
        this.isLoading = false;
        return this.numberOfLikes;
      }).catch(() => {
        this.isLoading = true;
        return this.numberOfLikes;
      });
    }
  }
});
</script>
